import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateHeatingCurvePresets',
})
export class TranslateHeatingCurvePresetsPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}
  transform(value: string): string {
    if (value) {
      value = value.charAt(0).toLowerCase() + value.slice(1);
      if (this.customTranslationsService.HEATING_CURVE_PRESETS[value]) {
        return this.translateService.instant(
          this.customTranslationsService.HEATING_CURVE_PRESETS[value]
        );
      }
    }

    return value;
  }
}
